import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { useMealPlanForUserStoreSelectors } from 'src/ztore/wss/meal-plan-for-user-store';

interface UseMealPlanDeliveryInfoResult {
  zipCode: string | undefined;
  regionId: number | undefined;
  deliveryHubId: string | number | null | undefined;
}

/**
 * Single source of truth for zip code / region / delivery hub in meal plan pages.
 *
 * Active meal plan → use the meal plan store (DB-backed, authoritative).
 * No meal plan     → fall back to the cached zip code from user preferences.
 */
export const useMealPlanDeliveryInfo = (): UseMealPlanDeliveryInfoResult => {
  const mealPlanForUser = useMealPlanForUserStoreSelectors.use.mealPlan?.();
  const [cachedZipCode, , zipCodeMetaData] = useCachedZipCode();

  if (mealPlanForUser?.zipCode?.zipCode) {
    return {
      zipCode: mealPlanForUser.zipCode.zipCode,
      regionId: mealPlanForUser.zipCode.regionId,
      deliveryHubId: mealPlanForUser.zipCode.deliveryHubId,
    };
  }

  return {
    zipCode: cachedZipCode ?? undefined,
    regionId: zipCodeMetaData?.cachedZipCodeData?.zipCode?.region?.id,
    deliveryHubId: zipCodeMetaData?.cachedZipCodeData?.zipCode?.deliveryHubId,
  };
};
